import { DocumentNode } from 'apollo-link';
import gql from 'graphql-tag';

export const DatabaseLineageCountsFragmentGql: DocumentNode = gql`
fragment DatabaseLineageCountsFragment on Database {
  unfilteredTablesConnection: tablesConnection {
    totalCount
  }
  upstreamDatabasesConnection {
    totalCount
  }
  upstreamTablesConnection {
    totalCount
  }
  upstreamFlowsConnection {
    totalCount
  }
  upstreamDatasourcesConnection {
    totalCount
  }
  downstreamDatabasesConnection {
    totalCount
  }
  downstreamTablesConnection {
    totalCount
  }
  downstreamVirtualConnectionsConnection @flag(enabled: $publishedConnectionsLineageEnabled) {
    totalCount
  }
  downstreamVirtualConnectionTablesConnection @flag(enabled: $publishedConnectionsLineageEnabled)  {
    totalCount
  }
  downstreamFlowsConnection {
    totalCount
  }
  downstreamDatasourcesConnection {
    totalCount
  }
  downstreamWorkbooksConnection {
    totalCount
  }
  downstreamDashboardsConnection {
    totalCount
  }
  downstreamSheetsConnection {
    totalCount
  }
  downstreamMetricsConnection {
    totalCount
  }
  downstreamOwnersConnection {
    totalCount
  }
}
`;
